<template>
  <v-container>
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" style="max-width: 400px" class="mb-3"
          :loading="searching"></v-text-field>
      </v-card-title>
      <v-data-table :sort-desc.sync="sortDesc" :sort-by.sync="sortBy" :headers="headers" :items="computedSuppliers"
        :footer-props="{
          'items-per-page-options': [5, 10, 15, 20],
        }" :items-per-page.sync="itemsPerPage" :page.sync="page" :server-items-length="supplierCount"
        :loading="fetching || searching || sorting" loading-text="Loading... Please wait" class="elevation-1">
        <template v-slot:item="row">
          <tr>
            <td>{{ row.item.id }}</td>
            <td>{{ row.item.name }}</td>
            <td>{{ row.item.address }}</td>
            <td>{{ row.item.subscription_date2 }}</td>
            <td>
              <v-tooltip bottom v-if="authPermissions.has('suppliers:edit')">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="mx-2" fab dark small v-bind="attrs" v-on="on" color="yellow"
                    @click="editSupplier(row.item)">
                    <v-icon dark>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Edit Supplier</span>
              </v-tooltip>
              <v-tooltip bottom v-if="authPermissions.has('suppliers:create')">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="mx-2" fab dark small v-bind="attrs" v-on="on" color="green"
                    @click="$router.push({ name: 'Supplier.Products', params: { supplier: row.item.id } })">
                    <v-icon dark>mdi-clipboard-file</v-icon>
                  </v-btn>
                </template>
                <span>Manage Supplier Product</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'vIndexSupplier',
  data() {
    return {
      searching: false,
      delayedSorting: null,
      sorting: false,
      delayedSearch: null,
      headers: [
        { text: 'Supplier ID', align: 'start', value: 'id' },
        { text: 'Name', value: 'name' },
        { text: 'Address', value: 'address' },
        { text: 'Date', value: 'subscription_date' },
        { text: 'Config', sortable: false },
      ],
      sortBy: [],
      sortDesc: [],
      search: null,
      itemsPerPage: 5,
      page: 1,
    }
  },
  mounted() {
    this.fetchDataCount({ search: this.search })
    this.fetchCurrentPage()
  },
  computed: {
    ...mapState({
      suppliers: state => state.supplier.list,
      supplierCount: state => state.supplier.dataCount,
      fetching: state => state.supplier.fetching,
      supplierUpdated: state => state.supplier.channelUpdate,
      authPermissions: state => state.auth.userPermissions,
    }),
    computedSuppliers() {
      return this.suppliers.map((e) => {
        const date = new Date(e.subscription_date)
        const year = date.getFullYear()
        const month = (`${date.getMonth() + 1}`).padStart(2, '0')
        const day = (`${date.getDate()}`).padStart(2, '0')
        return {
          ...e,
          subscription_date2: `${month}/${day}/${year}`,
        }
      })
    },
    computedSortBy() {
      return this.sortBy[0] === undefined ? '' : this.sortBy[0]
    },
    computedSortDesc() {
      const sortDesc = this.sortDesc[0] === undefined ? false : this.sortDesc[0]
      return sortDesc ? 'DESC' : 'ASC'
    },
  },
  watch: {
    itemsPerPage(val) {
      this.fetchCurrentPage()
    },
    page(val) {
      this.fetchCurrentPage()
    },
    supplierUpdated() {
      this.fetchDataCount({ search: this.search })
      this.fetchCurrentPage()
    },
    search() {
      this.searching = true
      clearTimeout(this.delayedSearch)
      this.delayedSearch = setTimeout(() => {
        this.searching = false
        this.page = 1
        this.fetchDataCount({ search: this.search })
        this.fetchCurrentPage()
      }, 1000)
    },
    sortDesc() {
      this.sorting = true
      clearTimeout(this.delayedSorting)
      this.delayedSorting = setTimeout(() => {
        this.sorting = false
        this.fetchCurrentPage()
      }, 1000)
    },
  },
  methods: {
    ...mapActions({
      fetch: 'supplier/fetch',
      fetchDataCount: 'supplier/fetchDataCount',
    }),
    editSupplier(supplierData) {
      this.$emit('editSupplier', supplierData)
    },
    fetchCurrentPage() {
      const pageOffset = (this.page - 1) * this.itemsPerPage
      this.fetch({
        index: pageOffset,
        count: this.itemsPerPage,
        search: this.search,
        sortBy: this.computedSortBy,
        sortDesc: this.computedSortDesc,
      })
    },
  },
}
</script>
